import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import {
  NetworkDeviceGroupDevicesDocument,
  NetworkUngroupedDevicesDocument,
} from '~/pages/device-groups/queries/devices.generated';
import { useNotifications, type ApiOptions } from '../helpers';
import { RemoveDevicesFromDeviceGroupDocument } from './remove-devices.generated';

export const useRemoveDevicesFromDeviceGroup = (
  options: ApiOptions<typeof RemoveDevicesFromDeviceGroupDocument> = {},
) => {
  const { t } = useTranslation();
  return useMutation(RemoveDevicesFromDeviceGroupDocument, {
    ...useNotifications(RemoveDevicesFromDeviceGroupDocument, {
      failure: (error) => error.message || t('api.common.error_generic'),
      success: (data) => {
        const count = data.removeDevicesFromDeviceGroup?.removedIds.length ?? 0;
        const name = data.removeDevicesFromDeviceGroup?.deviceGroup.name;
        return t('api.device_groups.remove_devices_success_plural', { count, name });
      },
    }),

    refetchQueries: [NetworkUngroupedDevicesDocument, NetworkDeviceGroupDevicesDocument],

    ...options,
  });
};
